<div
  class="header"
  appAccountColorBackground
  #backgroundDirective="appAccountColorBackground"
  [colorName]="panelDef.color"
>
  <div class="header__left">
    @if (!editMode) {
      <span
        class="header__left__title"
        [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        >{{ panelDef.title }}</span
      >
    } @else {
      <ts-icon icon="ts_pen" (click)="titleInput.focus()"></ts-icon>
      <input #titleInput [(ngModel)]="panelDef.title" />
    }
  </div>
  <div class="header__right">
    @if (!editMode) {
      <ng-content select="[customActions]"></ng-content>
      <button mat-icon-button type="button" [matMenuTriggerFor]="moreMenu">
        <ts-icon class="icon-size-20" icon="more_vert"></ts-icon>
      </button>
      <mat-menu #moreMenu>
        <button
          mat-menu-item
          (click)="startEditLayout.emit()"
          type="button"
          [appAuthorize]="PermissionSlot.MANAGE_LAYOUT | jupiterPermissionSlot"
          denyAction="disable"
        >
          <ts-icon icon="ts_pen"></ts-icon>
          Edit Layout
        </button>
      </mat-menu>
    } @else {
      <ng-content select="[editModeCustomActions]"></ng-content>
      <ts-button type="icon" color="basic" icon="cancel" matTooltip="Cancel" (click)="cancelEditLayout.emit()">
      </ts-button>
      <ts-button type="icon" color="basic" icon="save" matTooltip="Save" (click)="saveLayout.emit()"> </ts-button>
    }
  </div>
</div>
